import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "live_d6b31",
  "use": "live_d6b31-usage",
  "viewBox": "0 0 24 12",
  "content": "<symbol fill=\"none\" viewBox=\"0 0 24 12\" id=\"live_d6b31\">\n    <rect width=\"24\" height=\"12\" rx=\"2\" fill=\"#FF3F3F\" />\n    <path d=\"M5.193 8.007h2.533V9H4V3h1.193v5.007zM9.682 9H8.489V3h1.193v6zm3.248-1.488L14.243 3h1.328l-2.016 6H12.31l-2.008-6h1.324l1.304 4.512zM19.602 6.4h-2.29v1.607H20V9h-3.88V3h3.872v1.001h-2.68v1.43h2.29V6.4z\" fill=\"#fff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol